import { render, staticRenderFns } from "./submittedAlipay.vue?vue&type=template&id=cc7a06f6&scoped=true&"
import script from "./submittedAlipay.vue?vue&type=script&lang=js&"
export * from "./submittedAlipay.vue?vue&type=script&lang=js&"
import style0 from "./submittedAlipay.vue?vue&type=style&index=0&id=cc7a06f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7a06f6",
  null
  
)

component.options.__file = "submittedAlipay.vue"
export default component.exports